/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import {
  createFudo,
  deleteFudo,
  getFudo,
  updateFudo,
} from "../../../../utils/services/company";
import { useDispatch } from "react-redux";
import {
  selectLoadingUI,
  loadingOn,
  loadingOff,
} from "../../../../reducers/uiSlice";
import { Notification } from "../../../../containers/notification";
import { useSnackbar } from "notistack";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import { useNavigate } from "react-router-dom";

// CSS

import styles from "./styles.module.css";

//MATERIAL
import InputComponent from "../../../inputs";
import Toolbar from "../../../card/toolbar";
import jwt from "jsonwebtoken";
import config from "../../../../utils/config";
import { Checkbox, Tab, Tabs } from "@material-ui/core";
import { selectSubsidiaries } from "../../../../reducers/subsidiarySlice";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChangeLogs from "../../../changeLogs/changeLogs";

const logo = "https://s3.amazonaws.com/lumarketo.cl/fudotransparente.svg";

export default function FudoComponent() {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isTest, setIsTest] = useState(false);
  const [useShippingCost, setUseShippingCost] = useState(false);
  const [productIDForShippingCost, setProductIDForShippingCost] = useState("");
  const [updated, setUpdated] = useState(false);
  const [paymentId, setPaymentId] = useState(1);
  const [subsidiaryId, setSubsidiaryId] = useState();
  const [fudoId, setFudoId] = useState();
  const [useMockOrder, setUseMockOrder] = useState(false);
  const [mockProductId, setMockProductId] = useState("");
  const [useFailedShippingNotification, setUseFailedShippingNotification] =
    useState(false);
  const [
    productIdForFailedShippingNotification,
    setProductIdForFailedShippingNotification,
  ] = useState("");
  const subsidiaries = useSelector(selectSubsidiaries);
  const company = useSelector(selectCompany);
  const loading = useSelector(selectLoadingUI);
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { recordChange } = useChangeRecord();

  useEffect(() => {
    if (subsidiaries && subsidiaries.length > 0)
      setSubsidiaryId(subsidiaries[0]._id);
  }, [subsidiaries]);

  useEffect(() => {
    if (company && company._id !== "" && subsidiaryId && subsidiaryId !== "")
      initialize();
  }, [company, subsidiaryId]);

  const initialize = async () => {
    const found = await getFudo(company._id, subsidiaryId).catch((err) => {
      console.log(err);
      return null;
    });
    setClientId("");
    setClientSecret("");
    setUseShippingCost(false);
    setProductIDForShippingCost("");
    setUseMockOrder(found?.useMockOrder);
    setMockProductId(found?.mockProductId);
    if (found) {
      setFudoId(found?._id);
      if (found?.subsidiaryId) setSubsidiaryId(found?.subsidiaryId);
      if (found?.paymentId) setPaymentId(found?.paymentId);
      if (found?.clientId && found?.clientId !== "")
        setClientId(jwt.verify(found?.clientId, config.jwtSecret));
      else setClientId("");
      if (found?.clientSecret && found?.clientSecret !== "")
        setClientSecret(jwt.verify(found?.clientSecret, config.jwtSecret));
      else setClientSecret("");
      setIsTest(!!found?.isTest);
      if (found?.useShippingCost && found?.useShippingCost !== "")
        setUseShippingCost(found?.useShippingCost);
      if (
        found?.productIDForShippingCost &&
        found?.productIDForShippingCost !== ""
      )
        setProductIDForShippingCost(found?.productIDForShippingCost);
      else setProductIDForShippingCost("");

      if (
        found?.useFailedShippingNotification &&
        found?.useFailedShippingNotification !== ""
      )
        setUseFailedShippingNotification(found?.useFailedShippingNotification);
      if (
        found?.productIdForFailedShippingNotification &&
        found?.productIdForFailedShippingNotification !== ""
      )
        setProductIdForFailedShippingNotification(
          found?.productIdForFailedShippingNotification
        );
      else setProductIdForFailedShippingNotification("");
    }
  };

  const handleCancel = () => initialize();

  const handleSave = async () => {
    dispatch(loadingOn());
    const found = await getFudo(company._id, subsidiaryId).catch((err) => {
      console.log(err);
      return null;
    });
    if (found && !found?.clientId) {
      createFudo({
        companyId: company._id,
        clientId: jwt.sign(clientId, config.jwtSecret),
        clientSecret: jwt.sign(clientSecret, config.jwtSecret),
        isTest,
        productIDForShippingCost,
        useShippingCost,
        paymentId: Number(paymentId),
        subsidiaryId,
        useMockOrder,
        mockProductId,
        useFailedShippingNotification,
        productIdForFailedShippingNotification,
      })
        .then(async () => {
          dispatch(loadingOff());
          getCompany(company._id, dispatch);
          enqueueSnackbar(
            Notification({
              text: "Datos de la tienda actualizados",
              variant: "success",
              withDetails: false,
            })
          );
          setUpdated(false);
          await recordChange({
            module: "POS",
            submodule: "Fudo",
            changes: changes,
          });
        })
        .catch((err) => {
          enqueueSnackbar(
            Notification({
              text: "Error al actualizar datos de la tienda",
              variant: "error",
              withDetails: false,
            })
          );
          dispatch(loadingOff());
        });
    } else if (found && found?.clientId && found)
      updateFudo({
        companyId: company._id,
        clientId: jwt.sign(clientId, config.jwtSecret),
        clientSecret: jwt.sign(clientSecret, config.jwtSecret),
        isTest: isTest,
        productIDForShippingCost,
        useShippingCost,
        paymentId: Number(paymentId),
        subsidiaryId,
        useMockOrder,
        mockProductId,
        useFailedShippingNotification,
        productIdForFailedShippingNotification,
      })
        .then(async () => {
          dispatch(loadingOff());
          getCompany(company._id, dispatch);
          enqueueSnackbar(
            Notification({
              text: "Datos de la tienda actualizados",
              variant: "success",
              withDetails: false,
            })
          );
          setUpdated(false);
          await recordChange({
            module: "POS",
            submodule: "Fudo",
            changes: changes,
          });
        })
        .catch((err) => {
          enqueueSnackbar(
            Notification({
              text: "Error al actualizar datos de la tienda",
              variant: "error",
              withDetails: false,
            })
          );
          dispatch(loadingOff());
        });
  };
  const trackFieldChange = (field, oldValue, newValue, subsidiaryId) => {
    if (oldValue === newValue) return; // no change

    const logs = [...changes];

    const existing = logs.find(
      (l) => l.field === field && l?.subsidiaryId === subsidiaryId
    );
    const selectedSubsidiary = subsidiaries?.find(
      (f) => f?._id === subsidiaryId
    );

    const newLog = {
      field,
      text: `Cambió el campo ${field} para ${
        selectedSubsidiary ? selectedSubsidiary?.Name : "Todas las sucursales"
      }`,
      oldValue: existing ? existing.oldValue : oldValue,
      newValue,
      date: new Date().toISOString(),
      subsidiaryId,
    };

    if (existing) {
      const index = logs.findIndex((l) => l.field === field);
      logs[index] = newLog;
    } else {
      logs.push(newLog);
    }

    dispatch(setChanges(logs));
  };

  const handleRemove = async () => {
    dispatch(loadingOn());

    if (fudoId && fudoId !== "")
      deleteFudo(fudoId)
        .then(async () => {
          dispatch(loadingOff());
          getCompany(company._id, dispatch);
          await initialize();
          enqueueSnackbar(
            Notification({
              text: "Datos de la tienda actualizados",
              variant: "success",
              withDetails: false,
            })
          );
          setUpdated(false);
          await recordChange({
            field: "Servicio de Fudo",
            text: "Eliminación de credenciales",
            oldValue: "Credenciales registradas",
            newValue: "Credenciales eliminadas",
            date: new Date().toISOString(),
          });
        })
        .catch((err) => {
          enqueueSnackbar(
            Notification({
              text: "Error al actualizar datos de la tienda",
              variant: "error",
              withDetails: false,
            })
          );
          dispatch(loadingOff());
        });
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className={styles.parentContainer}>
      <div className={styles.changeLogsContainer}>
        <button className={styles.backButton} onClick={() => handleClose()}>
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>
        <ChangeLogs
          {...{
            module: "POS",
            submodule: "Fudo",
            subtitle: (
              <span>
                Historial de modfificación de credenciales de{" "}
                <strong>Fudo</strong>
              </span>
            ),
          }}
        />
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.titleLogoContainer}>
          <Toolbar title="Fudo" />
          <img src={logo} alt="logo" className={styles.imageElement} />
        </div>
        <div className={styles.infoDataContainer}>
          <p className={styles.textDescription}>
            Con las credenciales de FUDO podrás integrar tu sistema
            administrativo de restaurante en uno solo. Esto significa que los
            pedidos que recibas a través de NubeFood serán recibidos
            automáticamente en tu sistema FUDO, permitiéndote tener un control
            centralizado de todas las ventas diarias, así como también la
            generación de una boleta por cada pedido
          </p>

          {subsidiaries && (
            <div>
              <Tabs
                value={subsidiaryId}
                indicatorColor="primary"
                textColor="primary"
                onChange={(event, newValue) => setSubsidiaryId(newValue)}
                aria-label="disabled tabs example"
                variant="scrollable"
                scrollButtons="auto"
              >
                {subsidiaries.map((item) => (
                  <Tab label={item.Name} value={item._id} />
                ))}
              </Tabs>
            </div>
          )}
          <div className={styles.inputStackContainer}>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>ClientID</label>

              <InputComponent
                className={styles.inputElement}
                placeholder="Ej. 12345678901234"
                type="text"
                handler={(e) => {
                  setClientId(e.target.value);
                  trackFieldChange(
                    "ClientId",
                    clientId,
                    e.target.value,
                    subsidiaryId
                  );
                  setUpdated(true);
                }}
                disabled={loading}
                validation={clientId === ""}
                value={clientId}
              />
            </div>

            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>ClientSecret</label>
              <InputComponent
                className={styles.inputElement}
                placeholder="Ej. 12345678901234"
                type="text"
                handler={(e) => {
                  setClientSecret(e.target.value);
                  trackFieldChange(
                    "ClientSecret",
                    clientSecret,
                    e.target.value,
                    subsidiaryId
                  );
                  setUpdated(true);
                }}
                disabled={loading}
                validation={clientSecret === ""}
                value={clientSecret}
              />
            </div>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>Id del método de pago</label>
              <InputComponent
                className={styles.inputElement}
                placeholder="Ej. 1"
                type="text"
                handler={(e) => {
                  setPaymentId(e.target.value);
                  trackFieldChange(
                    "paymentId",
                    paymentId,
                    e.target.value,
                    subsidiaryId
                  );
                  setUpdated(true);
                }}
                disabled={loading}
                validation={paymentId === ""}
                value={paymentId}
              />
            </div>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>Activar modo prueba</label>

              <Checkbox
                checked={isTest}
                onChange={(e) => {
                  setIsTest(e.target.checked);
                  setUpdated(true);
                  trackFieldChange(
                    "Modo Prueba",
                    !isTest ? "Activo" : "Inactivo",
                    e.target.checked ? "Activo" : "Inactivo",
                    subsidiaryId
                  );
                }}
                value={"isTest"}
                style={{ color: "#122526" }}
              />
            </div>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>
                Incluir precio de envío
              </label>

              <Checkbox
                checked={useShippingCost}
                onChange={(e) => {
                  setUseShippingCost(e.target.checked);
                  setUpdated(true);
                  trackFieldChange(
                    "Incluir precio de envío",
                    !useShippingCost ? "Activo" : "Inactivo",
                    e.target.checked ? "Activo" : "Inactivo",
                    subsidiaryId
                  );
                }}
                value={"useShippingCost"}
                style={{ color: "#122526" }}
              />
            </div>
            {useShippingCost ? (
              <div className={styles.inputContainer}>
                <label className={styles.labelInput}>
                  ProductId para precio de envío
                </label>
                <InputComponent
                  placeholder="Ej. 12345678901234"
                  type="text"
                  handler={(e) => {
                    setProductIDForShippingCost(e.target.value);
                    trackFieldChange(
                      "productIDForShippingCost",
                      productIDForShippingCost,
                      e.target.value
                    );
                    setUpdated(true);
                  }}
                  disabled={loading}
                  validation={productIDForShippingCost === ""}
                  value={productIDForShippingCost}
                />
              </div>
            ) : null}
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>
                Crear orden provisional cuando se recibe un pedido con productId
                erróneo
              </label>
              <Checkbox
                checked={useMockOrder}
                onChange={(e) => {
                  setUseMockOrder(e.target.checked);
                  trackFieldChange(
                    "Creación de orden provicional",
                    !useMockOrder ? "Activo" : "Inactivo",
                    e.target.checked ? "Activo" : "Inactivo"
                  );
                  setUpdated(true);
                }}
                value={"useMockOrder"}
                style={{ color: "#122526" }}
              />
            </div>
            {useMockOrder ? (
              <div className={styles.inputContainer}>
                <label className={styles.labelInput}>
                  ProductId para orden provisional
                </label>
                <InputComponent
                  placeholder="Ej. 12345678901234"
                  type="text"
                  handler={(e) => {
                    setMockProductId(e.target.value);
                    trackFieldChange(
                      "mockProductId",
                      mockProductId,
                      e.target.value
                    );
                    setUpdated(true);
                  }}
                  disabled={loading}
                  validation={mockProductId === ""}
                  value={mockProductId}
                />
              </div>
            ) : null}
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>
                Crear orden de error de envío
              </label>
              <Checkbox
                checked={useFailedShippingNotification}
                onChange={(e) => {
                  setUseFailedShippingNotification(e.target.checked);
                  trackFieldChange(
                    "Crear orden de envío de error",
                    !useFailedShippingNotification ? "Activo" : "Inactivo",
                    e.target.checked ? "Activo" : "Inactivo"
                  );
                  setUpdated(true);
                }}
                value={"useFailedShippingNotification"}
                style={{ color: "#122526" }}
              />
            </div>
            {useFailedShippingNotification ? (
              <div className={styles.inputContainer}>
                <label className={styles.labelInput}>
                  ProductId para notificación de error de envío
                </label>
                <InputComponent
                  placeholder="Ej. 12345678901234"
                  type="text"
                  handler={(e) => {
                    setProductIdForFailedShippingNotification(e.target.value);
                    trackFieldChange(
                      "productIdForFailedShippingNotification",
                      productIdForFailedShippingNotification,
                      e.target.value
                    );
                    setUpdated(true);
                  }}
                  disabled={loading}
                  validation={productIdForFailedShippingNotification === ""}
                  value={productIdForFailedShippingNotification}
                />
              </div>
            ) : null}
            <div className={styles.buttonsContainer}>
              {clientId !== "" && (
                <button
                  onClick={() => {
                    handleRemove();
                  }}
                  className={styles.deleteButton}
                >
                  Eliminar
                </button>
              )}
              <button
                disabled={!updated}
                onClick={() => {
                  setUpdated(true);
                  handleCancel();
                }}
                className={styles.cancelButton}
              >
                Cancelar
              </button>
              <button
                disabled={!updated}
                className={styles.confirmButton}
                onClick={() => {
                  setUpdated(true);
                  handleSave();
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
